import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid1x3Horizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDotGrid1x3Horizontal"><Path d="M6 10H2V14H6V10Z" fill="currentColor"/><Path d="M14 10H10V14H14V10Z" fill="currentColor"/><Path d="M22 10H18V14H22V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3Horizontal;
